import { render } from "./addTemplate.vue?vue&type=template&id=7c08ecf6&scoped=true&ts=true"
import script from "./addTemplate.vue?vue&type=script&lang=ts"
export * from "./addTemplate.vue?vue&type=script&lang=ts"

import "./addTemplate.vue?vue&type=style&index=0&id=7c08ecf6&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c08ecf6"]])

export default __exports__